import { RRule, Weekday as RRuleWeekday } from "rrule";

/** Weekday. */
export enum Weekday {
    Monday = "monday",
    Tuesday = "tuesday",
    Wednesday = "wednesday",
    Thursday = "thursday",
    Friday = "friday",
    Saturday = "saturday",
    Sunday = "sunday",
}

export const WEEKDAY_LIST: readonly Weekday[] = [
    Weekday.Monday,
    Weekday.Tuesday,
    Weekday.Wednesday,
    Weekday.Thursday,
    Weekday.Friday,
    Weekday.Saturday,
    Weekday.Sunday,
];

export const WEEKDAY_TO_SHORT_READABLE: Readonly<Record<Weekday, string>> = {
    [Weekday.Monday]: "Пн",
    [Weekday.Tuesday]: "Вт",
    [Weekday.Wednesday]: "Ср",
    [Weekday.Thursday]: "Чт",
    [Weekday.Friday]: "Пт",
    [Weekday.Saturday]: "Сб",
    [Weekday.Sunday]: "Вс",
};

export const WEEKDAY_TO_RRULE_WEEKDAY: Readonly<Record<Weekday, RRuleWeekday>> = {
    [Weekday.Monday]: RRule.MO,
    [Weekday.Tuesday]: RRule.TU,
    [Weekday.Wednesday]: RRule.WE,
    [Weekday.Thursday]: RRule.TH,
    [Weekday.Friday]: RRule.FR,
    [Weekday.Saturday]: RRule.SA,
    [Weekday.Sunday]: RRule.SU,
};

export const WEEKDAY_FROM_RRULE_WEEKDAY: Readonly<Record<RRuleWeekday["weekday"], Weekday>> = {
    [RRule.MO.weekday]: Weekday.Monday,
    [RRule.TU.weekday]: Weekday.Tuesday,
    [RRule.WE.weekday]: Weekday.Wednesday,
    [RRule.TH.weekday]: Weekday.Thursday,
    [RRule.FR.weekday]: Weekday.Friday,
    [RRule.SA.weekday]: Weekday.Saturday,
    [RRule.SU.weekday]: Weekday.Sunday,
};
